import { render, staticRenderFns } from "./IconMediaTags.vue?vue&type=template&id=3e0b4b47&"
import script from "./IconMediaTags.vue?vue&type=script&lang=js&"
export * from "./IconMediaTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0b4b47')) {
      api.createRecord('3e0b4b47', component.options)
    } else {
      api.reload('3e0b4b47', component.options)
    }
    module.hot.accept("./IconMediaTags.vue?vue&type=template&id=3e0b4b47&", function () {
      api.rerender('3e0b4b47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMediaTags.vue"
export default component.exports